<template>
  <button
    type="button"
    class="editor-button"
    :class="{ high: high, active: active }"
    :disabled="disabled"
    v-on="$listeners"
  >
    <slot><n-icon :icon="icon" size="s" /></slot>
  </button>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class NEditorButton extends Vue {
  @Prop({ type: String }) icon!: string
  @Prop({ type: Boolean }) high?: boolean
  @Prop({ type: Boolean }) active?: boolean
  @Prop({ type: Boolean }) disabled?: boolean
}
</script>

<style scoped lang="scss">
@use '@/assets/styles' as *;

.editor-button {
  width: $notch-space-6x;
  height: $notch-space-6x;
  padding: $notch-space-1x;
  border: 0 solid transparent;
  border-radius: $notch-radius-full;

  background-color: transparent;

  color: $notch-color-neutral-sand-600;

  cursor: pointer;

  &:hover {
    background-color: $notch-color-neutral-sand-100;
  }

  &:focus {
    @include notch-style-focus;
    outline: none;
  }

  &:active {
    background-color: $notch-color-neutral-sand-200;
  }

  &.active {
    background-color: $notch-color-neutral-sand-200;
  }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
    background-color: transparent;
  }

  &.high {
    color: $notch-color-neutral-grey-900;
  }
}
</style>
